import React from "react"
import PropTypes from "prop-types"
import {
  Card,
  Icon,
  Label,
  Segment,
  Form,
  Button,
  Checkbox,
} from "semantic-ui-react"
import bind from "bind-decorator"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"

@withTranslation()
@withRouter
export default class CashboxCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editedData: props.createCashbox ? {} : false,
      errorName: false,
      errorStore: false,
      startFiscal: false,
      disabled: false,
      // editedData: props.create ? {} : false,
      // ? {
      //     roles: [],
      //     stores: props.storeOptions ? [props.storeOptions[0].value] : [],
      //   }
      // : false,
    }
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onChange({}, { value, checked, name }) {
    const { editedData } = this.state
    if (name === "disabled") {
      this.setState({
        disabled: checked,
      })
    } else if (editedData.name) {
      this.setState({ errorName: false })
    } else if (editedData.store) {
      this.setState({ errorStore: false })
    }
    if (name === "isMinus") {
      this.setState({
        editedData: {
          ...this.state.editedData,
          [name]: checked,
        },
      })
    } else {
      this.setState({
        editedData: {
          ...this.state.editedData,
          [name]: value,
        },
      })
    }
  }

  @bind
  startEditing() {
    const {
      disabled,
      isFiscal,
      storeAddress,
      storeName,
      name,
      id,
      fiscal,
      isMinus,
    } = this.props
    this.setState({
      editedData: {
        isFiscal,
        storeAddress,
        storeName,
        name,
        id,
        fiscal,
        isMinus,
      },
      disabled,
    })
  }

  @bind
  startFiscal() {
    const { id } = this.props
    this.setState({
      editedData: {
        wkLogin: "",
        wkPass: null,
        serialNumber: null,
        npfu: null,
        id,
      },
      startFiscal: true,
    })
  }

  @bind
  exitFiscal() {
    this.setState({
      editedData: null,
      startFiscal: false,
    })
  }

  @bind
  cancelEditing() {
    this.setState({
      editedData: false,
      deleteClicked: false,
    })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onDelete({}, { data }) {
    const { deleteClicked } = this.state
    const { deleteCashbox } = this.props
    if (deleteClicked) {
      deleteCashbox(data)
      this.setState({
        deleteClicked: false,
      })
    }
    this.setState({
      deleteClicked: true,
    })
  }

  @bind
  onSave() {
    const { editCashbox, fiscalCashbox, refresh } = this.props
    const { editedData, disabled } = this.state
    if (this.state.startFiscal) {
      const data = {
        id: editedData.id,
        wklogin: editedData.wkLogin,
        wkpass: editedData.pass,
        serialNumber: editedData.serialNumber.toUpperCase(),
        npfu: editedData.npfu,
      }
      fiscalCashbox(data)
      this.exitFiscal()
      refresh()
    } else {
      if (editedData.name) {
        this.setState({
          errorName: false,
        })
        const sendData = {
          id: editedData.id,
          isFiscal: editedData.isFiscal,
          name: editedData.name,
          storeAddress: editedData.storeAddress,
          storeName: editedData.storeName,
          disabled: disabled,
          isMinus: editedData.isMinus,
        }
        editCashbox(sendData)
        this.cancelEditing()
      } else {
        if (!editedData.name) {
          this.setState({
            errorName: true,
          })
        }
      }
    }
  }

  @bind
  onCreate() {
    const { createCashbox, cancelCreating } = this.props
    const { editedData } = this.state
    if (editedData.name && editedData.store) {
      this.setState({ errorName: false, errorStore: false })
      createCashbox(editedData)
      cancelCreating()
    } else {
      if (!editedData.name) {
        this.setState({ errorName: true })
      }
      if (!editedData.store) {
        this.setState({ errorStore: true })
      }
    }
    // this.props.history.push("/")
  }

  renderFiscalingData() {
    const {
      editedData: { wkLogin, pass, serialNumber, npfu },
    } = this.state
    const { t } = this.props
    return [
      <Card.Content key="1">
        <Form autoComplete="off">
          <Form.Input
            label="Логин (Оператор ККМ) "
            type="text"
            name="wkLogin"
            id="wkLogin"
            value={wkLogin}
            onChange={this.onChange}
          />
          <Form.Input
            label="Пароль (Оператор ККМ)"
            type="password"
            name="pass"
            id="wkPass"
            value={pass}
            onChange={this.onChange}
          />
          <Form.Input
            label={t("serialNumber")}
            type="text"
            name="serialNumber"
            value={serialNumber}
            onChange={this.onChange}
          />
          <Form.Input
            label={t("registerIdCashbox")}
            type="text"
            name="npfu"
            value={npfu}
            onChange={this.onChange}
            error={npfu && npfu.length !== 12}
            icon={
              npfu &&
              (npfu.length === 12 ? (
                <Icon name="check" color="green" />
              ) : (
                <Icon name="x" color="red" />
              ))
            }
          />
        </Form>
      </Card.Content>,
      <Card.Content key="2" extra>
        <Button onClick={this.exitFiscal}>{t("cancel")}</Button>
        <Button
          color="green"
          onClick={this.onSave}
          disabled={(pass, serialNumber, npfu) === null}
        >
          {t("fiscalize").capitalize()}
        </Button>
      </Card.Content>,
    ]
  }

  renderEditingData() {
    const {
      editedData: {
        isFiscal,
        storeAddress,
        stores,
        storeName,
        name,
        id,
        fiscal,
        isMinus,
      },
      disabled,
      deleteClicked,
      errorName,
      errorStore,
    } = this.state
    const {
      // id,
      storeOptions,
      createCashbox,
      cancelCreating,
      isCreate,
      t,
    } = this.props

    return [
      <Card.Content key="1">
        {isCreate ? (
          <Form>
            <Form.Input
              label={t("nameCashbox")}
              type="text"
              name="name"
              error={errorName}
              value={name || ""}
              onChange={this.onChange}
            />
            {errorName && (
              <Label basic color="red" pointing>
                {t("enterStoreName")}
              </Label>
            )}
            <Form.Select
              options={storeOptions}
              label={t("store").capitalize()}
              name="store"
              error={errorStore}
              value={stores}
              onChange={this.onChange}
            />
            {errorStore && (
              <Label basic color="red" pointing>
                {t("selectStorage")}
              </Label>
            )}
            <Checkbox
              onChange={this.onChange}
              name="isMinus"
              label={t("Trade negative")}
              checked={isMinus}
            />
          </Form>
        ) : (
          <Form>
            <Form.Input
              label={t("nameCashbox")}
              type="text"
              name="name"
              error={errorName}
              value={name || ""}
              onChange={this.onChange}
            />
            {errorName && (
              <Label basic color="red" pointing>
                {t("requiredField")}
              </Label>
            )}
            <Form.Input
              label={t("store").capitalize()}
              name="storeName"
              value={storeName}
              disabled
            />
            <Form.Input
              label={t("addressStore")}
              name="storeAddress"
              value={storeAddress || ""}
              disabled
            />
            <Checkbox
              onChange={this.onChange}
              name="isMinus"
              label={t("Trade negative")}
              checked={isMinus}
            />
            <p></p>
            {false && (
              <Form.Input
                type={
                  <Checkbox
                    label={"Ubrat' fiskal'niy rezhim"}
                    checked={!this.state.editedData.isFiscal}
                    onChange={() => {
                      const old = { ...this.state.editedData }
                      old.isFiscal = !old.isFiscal
                      this.setState({ editedData: old })
                    }}
                  />
                }
              />
            )}
            {isFiscal && (
              <>
                <Form.Input
                  label="Логин (веб-касса)"
                  type="text"
                  name="wkLogin"
                  value={fiscal.wkLogin}
                  onChange={this.onChange}
                  disabled
                />
                <Form.Input
                  label="Пароль (веб-касса)"
                  type="password"
                  name="wkPass"
                  value={fiscal.wkPass}
                  onChange={this.onChange}
                  disabled
                />
                <Form.Input
                  label={t("serialNumber")}
                  type="text"
                  name="serialNumber"
                  value={fiscal.serialNumber}
                  onChange={this.onChange}
                  disabled
                />
                <Form.Input
                  label={t("registrationNumber")}
                  type="text"
                  name="npfu"
                  value={fiscal.npfu}
                  onChange={this.onChange}
                  disabled
                />
              </>
            )}
            <Checkbox
              label={t("disconnected")}
              checked={disabled}
              onChange={this.onChange}
              name="disabled"
            />
          </Form>
        )}
      </Card.Content>,
      createCashbox ? (
        <Card.Content key="2" extra>
          <Button color="green" onClick={this.onCreate}>
            {t("create")}
          </Button>
          <Button basic onClick={cancelCreating}>
            {t("cancel")}
          </Button>
        </Card.Content>
      ) : (
        <Card.Content key="2" extra>
          <Button color="green" onClick={this.onSave}>
            {t("save")}
          </Button>
          <Button basic onClick={this.cancelEditing}>
            {t("cancel")}
          </Button>
          <Button
            basic={!deleteClicked}
            color="red"
            data={id}
            floated="right"
            onClick={this.onDelete}
          >
            {deleteClicked ? t("confirmDelete") : t("delete")}
          </Button>
        </Card.Content>
      ),
    ]
  }

  renderData() {
    const {
      disabled,
      isFiscal,
      storeAddress,
      storeName,
      name,
      id,
      t,
      fiscal,
      isMinus,
    } = this.props
    return (
      <Card.Content>
        <Card.Header>
          <Label attached="top right" as="a" onClick={this.startEditing}>
            <Icon name="pencil" fitted /> {t("change").toLowerCase()}
          </Label>
          {!isFiscal && (
            <Label
              attached="bottom right"
              as="a"
              onClick={this.startFiscal}
              color="green"
            >
              <Icon name="pencil" fitted /> {t("fiscalize")}
            </Label>
          )}
        </Card.Header>
        <div
          className="cashbox_card"
          onClick={() =>
            this.props.history.push({
              pathname: `cashboxinfo/${this.props.id}`,
              state: name,
            })
          }
        >
          <p>
            <strong>{t("nameCashbox")}:&nbsp;</strong>
            {name}
          </p>
          <p>
            <strong>{t("idCashbox")}:&nbsp;</strong>
            {id}
          </p>
          <p>
            <strong>{t("titleStore")}:&nbsp;</strong>
            {storeName}
          </p>
          <p>
            <strong>{t("addressStore")}:&nbsp;</strong>
            {storeAddress}
          </p>
          <p>
            <strong>{t("Trade negative")}:&nbsp;</strong>{" "}
            {!isMinus ? "✖️" + t("no") : "✔️" + t("yes")}
          </p>
          <p>
            <strong>{t("state")}:&nbsp;</strong>{" "}
            {disabled ? "✖️" + t("disconnected") : "✔️" + t("connected")}
          </p>
          <p>
            <strong>{t("fiscal")}:&nbsp;</strong>
            {isFiscal ? "✔️" + t("fiscalized") : "✖️" + t("notFiscalized")}
          </p>
          {isFiscal ? (
            <p>
              <strong>{"Осталось" + ": "}</strong>
              {fiscal.daysLeft + " " + t("numDays")}
            </p>
          ) : (
            <></>
          )}
        </div>
      </Card.Content>
    )
  }

  render() {
    const { t } = this.props
    const { editedData, startFiscal } = this.state
    const { isLoading } = this.props
    return (
      <Card fluid as={Segment} loading={isLoading}>
        {editedData && !startFiscal
          ? this.renderEditingData()
          : editedData && startFiscal
          ? this.renderFiscalingData()
          : this.renderData()}
      </Card>
    )
  }
}

CashboxCard.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  storeName: PropTypes.string,
  storeAddress: PropTypes.string,
  store: PropTypes.number,
  storeOptions: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  deleteCashbox: PropTypes.func,
  editCashbox: PropTypes.func,
  createCashbox: PropTypes.func,
  cancelCreating: PropTypes.func,
}
